import { gsapAnimationManager } from '../../animation/gsapAnimations'

// 資訊視窗管理類
export class InfoWindowManager {
  constructor (dom, state) {
    this.DOM = dom
    this.state = state
  }

  fadeInInfoWindow (site) {
    if (!this.DOM.infoWindow) return

    if (this.DOM.infoWindow.style.display === 'block' &&
      this.state.currentInfoSite === site.name) {
      this.DOM.infoWindow.querySelector('.ifm-group__title h4').textContent = site.name
      return
    }

    this.state.currentInfoSite = site.name
    this.DOM.infoWindow.style.display = 'block'
    this.DOM.infoWindow.querySelector('.ifm-group__title h4').textContent = site.name
    gsapAnimationManager.fadeInInfoWindow(this.DOM.infoWindow)
  }

  fadeOutInfoWindow () {
    if (!this.DOM.infoWindow) return
    gsapAnimationManager.fadeOutInfoWindow(this.DOM.infoWindow, {
      duration: 0.2,
      onComplete: () => {
        this.DOM.infoWindow.style.display = 'none'
      }
    })
  }

  registerCloseButton (iconLayer, iconHandler) {
    const closeBtn = this.DOM.infoWindow.querySelector('.ifm-group__close-btn')
    if (!closeBtn) return

    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation()

      // 找到當前展開的母圖標組（g 元素）
      const expandedIconGroup = iconLayer.selectAll('[data-site-id][data-expanded="true"]')
      if (expandedIconGroup.size()) {
        // 從母圖標組的 data-site-id 屬性獲取站點資訊
        const siteId = expandedIconGroup.attr('data-site-id')

        // 從 vm.siteData 中找到對應的站點數據
        let foundSiteInfo = null
        if (iconHandler.vm && iconHandler.vm.siteData && siteId) {
          foundSiteInfo = iconHandler.vm.siteData.find(site => {
            const currentSiteId = site.id || `${site.county}-${site.lat}-${site.lon}`
            return currentSiteId === siteId
          })
        }

        if (foundSiteInfo && iconHandler && iconHandler.collapseChildIcons) {
          // 使用 iconHandler 的收合動畫
          iconHandler.collapseChildIcons(foundSiteInfo)
        }
      }

      // 重置圖標狀態
      iconLayer.selectAll('image')
        .attr('data-expanded', null)
      iconLayer.selectAll('.progress-bg')
        .classed('image-focus-shadow', false)

      this.fadeOutInfoWindow()
      this.state.hasChildIcons = false
    })
  }
}
